import { Component, OnInit, ViewContainerRef, ViewChild, NgModule, Compiler } from '@angular/core';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RoutingValidationService } from "../../services/routingValidation/routing-validation.service";
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { WelcomeService } from "../../services/welcome/welcome.service";
import { ConfigurationService } from "../../services/configuration/configuration.service";
import { WelcomeDTO } from "../../model/welcome.info";
import { CONFIG } from "../../constants/constants";
import { ITEMS_EJEMPLO } from "../../constants/itemsEjemplo";
import { ItemExampleDTO } from "../../model/item.example.dto";
import { ESTADO_SESSION_INFO } from '../../model/estadoSessionInfo';
import { LoginService } from "../../services/login/login.service";
import { TokenControlService } from "../../services/state/tokenControl.service";

/** Variable scope para Jquery */
declare var $: any;
//Variable del global scope para funcionamiento de MathJax
declare var MathJax: any;

@Component({
  selector: 'app-items-example',
  templateUrl: './items-example.component.html',
  styleUrls: ['./items-example.component.css']
})
export class ItemsExampleComponent implements OnInit {

  //Inyeccion del componente interno que compilara el html de los items
  @ViewChild('containerEjemplo', { read: ViewContainerRef, static: false })
  containerEjemplo: ViewContainerRef;

  //Almacena toda la informacion de la pagina de bienvenida
  public welcomeData: WelcomeDTO;

  //Flag que indica si hay conexion a internet o no
  public online: boolean;

  /** identificador del item actual */
  public indiceItem: number;

  /** Flag para mostrar finalizar */
  public mostrarFinalizar: Boolean;

  /** Flag para mostrar Anterior */
  public mostrarAnterior: Boolean;

  /** Flag para mostrar Instructivos */
  public showInstruccion: Boolean;

  /** Flag para mostrar scrollButton */
  //public showScrollBtn: Boolean;

  /** Almacena los tipos de items del examen */
  public listaItemsEjemplo: ItemExampleDTO[];

  /** Bandera para items preIcfes comunicacionEscrita */
  public showsimulationButtons: Boolean;

  /** Flag para mostrar isntruccion INSOR */
  public showINSOR: Boolean;

  /** Almacena urls de descarga de Archivos */
  public urlsDescarga: string[];

  /** Almacena urls de descarga de Archivos */
  public ejemplosPrueba: string[];

  /** aginas a tener en cuenta en isntruccion */
  public paginas: string;

  constructor(private _translateService: TranslateService,
    private _loginService: LoginService,
    private _tokenController: TokenControlService,
    public _configurationControlService: ConfigurationControlService,
    private _welcomeDataService: WelcomeService,
    private _routingValidationService: RoutingValidationService,
    private _configurationService: ConfigurationService,
    public _compiler: Compiler,
    private _router: Router) {

    this.welcomeData = this._welcomeDataService.data;

    this._translateService.addLangs(["es", "en"]);
    this._translateService.setDefaultLang("es");
    this._translateService.use("es");

    this.mostrarFinalizar = false;
    this.mostrarAnterior = false;
    this.showInstruccion = true;
    //this.showScrollBtn = false;
    this.listaItemsEjemplo = [];
    if (this._configurationControlService.ambiente == "preIcfes") {
      this.showsimulationButtons = false;
      this.showInstruccion = false;
    } else {
      this.showsimulationButtons = true;
    }
    if (this._configurationControlService.examConfiguration.tourTest == "INSOR") {
      this.showINSOR = true;
    } else {
      this.showINSOR = false;
    }

    this.urlsDescarga = [];
    this.ejemplosPrueba = [];
    this.paginas = ";"
  }

  ngOnInit() {
    this.loadUrls();
    this._configurationService.inhabilitarBotonAtras();
    this.indiceItem = 0;
    this.loadInfo();
    if (!this.showINSOR) {
      setTimeout(function () {
        $("#contenedor").css("width", "450px");
      }, 200);
    }
  }

  /** Se encarga de cargar las url de Descarga */
  private loadUrls() {
    switch (this._welcomeDataService.idCombo) {
      case CONFIG.TEST_CODE_PA_PRO:
        this.urlsDescarga.push("Guia de orientacion modulos de competencias genericas saber-pro-2019.pdf",
          "Cuadernillo de preguntas comunicacion escrita Saber Pro 2018.pdf",
          "Infografia de comunicacion escrita saber pro 2019.pdf");

        this.ejemplosPrueba.push("¿Estás de acuerdo con que en Colombia se permita a los menores de 14 años realizarse procedimientos estéticos?",
          "¿Estás de acuerdo con que en Colombia se eliminen los impuestos de circulación para los vehículos eléctricos? ")

        this.paginas = "38 y 39";

        break;

      case CONFIG.TEST_CODE_PA_TYT:
        this.urlsDescarga.push("Guia de orientacion modulos de competencias genericas saber tyt 2019-1.pdf",
          "Cuadernillo de preguntas comunicacion escrita tyt.pdf",
          "Infografia comunicacion escrita Saber TyT.pdf");

        this.ejemplosPrueba.push("¿Está de acuerdo con la afirmación de que cobrar impuestos a las bolsas de plástico es una medida que beneficiará a los fabricantes?",
          "Algunas personas consideran que las competencias deportivas nacionales e internacionales son utilizadas con fines políticos y comerciales. ¿Está usted de acuerdo con esta afirmación? ")

        this.paginas = "24 y 25";
        break
    }

  }

  /** Método encargado de cosntruir el array de items de Ejemplo */
  public loadInfo() {
    if (this._configurationControlService.idPrueba != null) {
      this.showInstruccion = false;
      this.showsimulationButtons = false;
    } else {
      let tiposItem: string[] = this._welcomeDataService.data.tiposItem;
      let contIngles = false;
      for (let i = 0; i < tiposItem.length; i++) {
        switch (tiposItem[i]) {
          case "single":
            this.listaItemsEjemplo.push(new ItemExampleDTO("single", ITEMS_EJEMPLO.single));
            break;
          case "grid":
            this.listaItemsEjemplo.push(new ItemExampleDTO("grid", ITEMS_EJEMPLO.grid));
            break;
          case "open":
            this.listaItemsEjemplo.push(new ItemExampleDTO("open", ITEMS_EJEMPLO.open));
            break;
          case "ing_p2":
            this.listaItemsEjemplo.push(new ItemExampleDTO("ing_p2", ITEMS_EJEMPLO.ing_p2));
            break;
          case "ing_p4":
          case "ing_p7":
            if (!contIngles) {
              contIngles = true;
              this.listaItemsEjemplo.push(new ItemExampleDTO("ing_p4_p7", ITEMS_EJEMPLO.ing_p4_p7));
            }
            break
          case "insor":
            this.listaItemsEjemplo.push(new ItemExampleDTO("insor", ITEMS_EJEMPLO.insor));
            break;
        }
      }
    }

  }

  public startSimulation() {
    this._loginService.saveSessionInfo(this._tokenController.getTokenValue(), this._tokenController.token.tokenId, ESTADO_SESSION_INFO.INICIAR_SIMULACION);
    this.showInstruccion = false;
    this.addComponent();
    this.renderButtons();
  }

  public endTest() {
    if (this._configurationControlService.ambiente == "preIcfes") {
      this._router.navigate(['/welcomePreIcfes']);
    } else {
      this._router.navigate(["/demo"]);
    }
  }

  private addComponent() {

    this.containerEjemplo.clear();

    let template = this.listaItemsEjemplo[this.indiceItem].contenidoItem;

    @Component({ template: template })
    class TemplateComponent {

      public respAng: any;
      public _answerController: any[];

      /*almacena las respuestas de preguntas de tipo grilla*/
      public respsAng: any[];
      //constante que contiene la url base de los recursos (imagenes, videos)
      public rutaBase: string = CONFIG.RUTA_BASE;

      constructor() {
        this._answerController = [];
        this._answerController.push({ "open": "" });
        this.respsAng = [];

        for (let i = 0; i < 20; i++) {
          this.respsAng[i] = 'O';
        }
      }

      public answer(value: any) {

      }

      public validarTamFile(e) {
      }
      //Se encarga del cargue de los videos
      public loadAnotherVideo(url: any) {
        url = this.rutaBase + url;
        var video = document.getElementsByTagName('video')[0];
        var sources = video.getElementsByTagName('source');
        sources[0].src = url;
        video.load();
        video.play();
      }

    }

    @NgModule({
      declarations: [TemplateComponent], imports: [FormsModule, ReactiveFormsModule, CKEditorModule]
    })

    class TemplateModule {

    }
    const mod = this._compiler.compileModuleAndAllComponentsSync(TemplateModule);
    const factory = mod.componentFactories.find((comp) =>
      comp.componentType === TemplateComponent
    );
    const component = this.containerEjemplo.createComponent(factory);
    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
  }

  /** Metodo encargado de avanzar en la lista de items */
  public stepForward() {
    this.indiceItem += 1;
    this.renderButtons();
    this.addComponent();
    this.configOpenAnswer()
    //this.checkScroll();
  }

  /** Metodo encargado de retroceder en la lista de items */
  public stepBack() {
    this.indiceItem -= 1;
    this.renderButtons();
    this.addComponent();
    this.configOpenAnswer()
    //this.checkScroll();
  }

  /** Metodo encargado de validar la visualización de botones */
  public renderButtons() {
    let cantItems = this.listaItemsEjemplo.length;
    if (this.indiceItem > 0) {
      this.mostrarAnterior = true;
    } else {
      this.mostrarAnterior = false;
    }
    if (cantItems == this.indiceItem + 1) {
      this.mostrarFinalizar = true;
    } else {
      this.mostrarFinalizar = false;
    }
  }

  /** Método encargado de terminar la simulación */
  public endSimulation() {
    $("#finishSimulationModal").modal("show");
  }

  /** Método encargado de direccionar a la vista de inicio de examen */
  public startExam() {
    this._configurationControlService.examConfiguration.showSimulation = false;
    this._routingValidationService.validateRouting("simulateToExam");
  }

  /*Se encarga de verificar si es necesario mostrar el scroll
  cuando hay un cambio de item*/
  /*public checkScroll() {
    let video = $("video"); video.attr("controlsList", "nodownload");
    this.showScrollBtn = false;
    let self = this;
    setTimeout(function () {
      let docHeight = $(window).height() * 0.67;
      let divHeight = $("#divScroll").height();
      if (divHeight > docHeight) {
        self.showScrollBtn = true;
      }
      else {
        self.showScrollBtn = false;
      }
    }, 500);
  }*/

  /** Método encargado de implementar restricciones al editor de texto ckeditor */
  public configOpenAnswer() {
    let self = this;
    setTimeout(function () {
      if (self.listaItemsEjemplo[self.indiceItem].tipoItem == 'open') {
        $("#cke_3_contents").find("iframe").attr('id', 'idframe')
        $("#idframe").contents().find("body").attr('onpaste', 'return false')
        $("#idframe").contents().find("body").attr('id', 'bodyIframe')
        $("#idframe").contents().find("#bodyIframe").keyup(function () {
          let maxlength = 2700;
          let totalWords = $("#idframe").contents().find("#bodyIframe p").text().length;
          if (totalWords >= maxlength) {
            $("#modalChar").modal("show");
          }
        });
      }
    }, 1000);

  }

}
